<script setup lang="ts">
import type { SubjectCode } from '~/models/Subject'
import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from '#imports'
import useSubjectsStore from '~/stores/subjects'
import { useAuthStore } from '~/stores/auth'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import Select from '~/components/ui/Select.vue'

const { t } = useI18n()
const router = useRouter()
const { currentSubject } = storeToRefs(useSubjectsStore())
const { userSubjectsByGrades } = useAuthStore()
const { inSubjectView } = useUrlBuilder()

const selectedSubject = ref<SubjectCode>()

watch(currentSubject, () => {
  selectedSubject.value = currentSubject.value
}, { immediate: true })

const onSelect = () => {
  if (!selectedSubject.value && !inSubjectView)
    return
  router.push({
    name: 'subject',
    params: { subject: (selectedSubject.value as string).toLowerCase() }
  })
}
</script>

<template>
  <Select
    v-if="userSubjectsByGrades.length"
    v-model="selectedSubject"
    :options="userSubjectsByGrades"
    :option-label="(subject: SubjectCode) => t(`metadata.subjects.${subject}`)"
    :placeholder="$t('filters.chooseSubject')"
    variant="outline"
    size="lg"
    @update:model-value="onSelect"
  />
</template>
